<template>
    <div id='app-main-container'>
        <div v-if='route == "itim_shop"' class='itim-shop-container'>
            <!-- <Header v-show='show_top_navigation' :updated_cart_watcher='updated_cart_watcher'/> -->
                        <LockItInHeader v-if='subscription_type == "lock_it_in" && show_lock_it_in_header' :updated_cart_watcher='updated_cart_watcher' :current_route='current_route' :login_changed='login_changed' />
            <WineClubHeader v-if='subscription_type == "wineclub" && show_wine_club_header' :updated_cart_watcher='updated_cart_watcher' :login_changed='login_changed' />
            <div class="main-body remove-margin">
                <!-- <Banner v-show='show_top_navigation'/> -->
                <router-view :key="$route.fullPath" class="page-content" @updatedCartListener='updatedCartListener' :popstate_event='popstate_event' v-bind:user_info="user_info" @loggedInListener='loggedIn'/>
            </div>

            <Footer v-show='show_footer'/>
        </div>

        <div v-if='route == "admin_control_panel"' class='admin-control-panel-container'>
            <AdminSideBar v-show='show_admin_side_bar' v-if="admin_logged_in" :page_name='page_name' :menu_expanded='admin_side_menu_expanded' @selectedMenuOptionListener="getPageTitle"/>
            <div class='admin-control-inner-wrapper'>
                <AdminTopBar v-show='show_admin_top_bar' v-if="admin_logged_in" :admin_user_info="admin_user_info" :page_title="page_title"/>
                <div class="admin-control-panel-body" :class="{'body-no-padding' : !show_admin_side_bar}">
                    <router-view :key="$route.fullPath" class="page-content" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	import Header from '@/ecom/components/navigation/Header'
	import Footer from '@/ecom/components/footer/Footer'
    import Banner from '@/ecom/components/navigation/Banner.vue';
    import AdminSideBar from '@/ecom_cms/components/navigation/AdminSideBar.vue';
    import AdminTopBar from '@/ecom_cms/components/navigation/AdminTopBar.vue';
    import {checkAuth, setMetaTags, formatUrlForCachedFiles, checkOmetriaLoaded} from "@/global/modules/functions.js";
    import LockItInHeader from '@/ecom/components/header/lock_it_in/LockItInHeader.vue';
    import WineClubHeader from '@/ecom/components/header/wineclub/WineClubHeader.vue';
    import { computed } from 'vue'

    export default {
        name: 'App',
        components : {Header, Footer, Banner, AdminSideBar, AdminTopBar, WineClubHeader, LockItInHeader},
        provide() {
            return {
                mobile_mode: computed(() => this.mobile_mode) //Inject to all children components
            }
        },
        data() {
            return {
                updated_cart_watcher: null,
                show_top_navigation: true,
                show_footer: true,
                route: 'itim_shop',
                admin_logged_in: false,
                admin_user_info: null,
                page_title: '',
                page_name: '',
                admin_side_menu_expanded: true,
                popstate_event: null,
                wineclub: false,
                subscription_type: '',
                show_admin_top_bar: true,
                show_admin_side_bar: true,
                show_lock_it_in_header: true,
                show_wine_club_header: true,
                current_route: {},
                login_changed: null,
                screen_size_check_timeout: null,
                mobile_mode: false,
                user_info: null
            }
        },
        methods:{
            updatedCartListener(){
               this.updated_cart_watcher = +new Date();
            },
            setTheme(theme){
                document.documentElement.className = theme;
            },
            async checkAdminAccessTemp() {
                let response = await fetch(`/api/admin-access-check-temp`, {
                    method: 'GET',
                    credentials: 'include'
                });

                let results = await checkAuth(response);
                
                if (response.status === 200){
                    if(!results){
                        window.location.href = '/';
                    }
                }
            },
            async checkAdminAccess() {
                let response = await fetch(`/api/userrole-access-check`, {
                    method: 'GET',
                    credentials: 'include'
                });

                let results = await checkAuth(response);
                
                if (response.status === 200){
                    this.admin_logged_in = results.is_logged_in;
                    this.admin_user_info = results;
                }
            },
            getPageTitle(title) {
                this.page_title = title;
            },
            handleSubscriptionHeaders(to){
                this.show_lock_it_in_header = false;
                this.show_wine_club_header = true;
                
                if(to.path.includes('lock-it-in')) {
                    this.subscription_type = 'lock_it_in';

                    this.show_lock_it_in_header = true;
                }

                if(to.path.includes('wineclub') || to.path.includes('wine-club')) {
                    this.subscription_type = 'wineclub';

                    if(to.path == '/wine-club' || to.path == '/wine-club/' || to.path == '/wine-club/send-a-gift' || to.path == '/wine-club/send-a-gift'){
                        this.show_wine_club_header = false;
                    }
                }

                /* If pdp or plp page, these pages won't have /wine-club/ in the url, so need to detect on these pages and set header */
                this.setLockItinHeaderOnDynamicPages(to);

            },
            loggedIn(){
                this.login_changed = +new Date();
            },
            async setLockItinHeaderOnDynamicPages(to){

                /* If pdp or plp page, these pages won't have /wine-club/ in the url, so need to detect on these pages and set header.
                    Can't load them dicrectly on pdp or plp due to dynamic router casuing double imports
                */
                try{
                    let formatted_route = formatUrlForCachedFiles(to.path);

                    const response = await fetch(`/cached_routes/${formatted_route}.json`);

                    if (!response.ok){
                        throw new Error('Route not found');
                    }

                    const route = await response.json();

                    if(route.type == 'plp'){
                        this.subscription_type = 'lock_it_in';
                        this.show_lock_it_in_header = true;
                    }

                    if(route.type == 'pdp'){
                        this.subscription_type = 'lock_it_in';
                        this.show_lock_it_in_header = true;
                    }

                    return;
                }
                catch(e){
           
                }
            },
            CheckMobileMode(){
            let app_container = document.getElementById('app-main-container');
                if(typeof app_container !== 'undefined'){
                    new ResizeObserver(()=>{
                        clearTimeout(this.screen_size_check_timeout);

                        this.screen_size_check_timeout = setTimeout(() => { //Set timeout to stop ResizeObserver loop completed with undelivered notifications error
                            if(app_container.clientWidth <= 768){
                                this.mobile_mode = true;
                            }
                            else{
                                this.mobile_mode = false;
                            }
                        }, 1);
                    }).observe(app_container);
                }
            },
            async getUserInfo() {
                let response = await fetch(`/api/user`, {
                    method: 'GET',
                    credentials: 'include'
                });

                let results = await checkAuth(response);
                
                if (response.status === 200){
                    this.user_info = results.user_details;
                }
            },
            async trackOtherPages(to) {
                try{
                    let formatted_route = formatUrlForCachedFiles(to.path);
                    const response = await fetch(`/cached_routes/${formatted_route}.json`);

                    if (!response.ok){
                        throw new Error('Route not found');
                    }

                    const route = await response.json();
                    if(route.type != 'plp' && route.type != 'pdp' && checkOmetriaLoaded()){
                        if(to.path.includes('/home')) {
                            window.ometria.init('homepage', null, '501')
                        } else {
                            window.ometria.init('other', null, '501')
                        }
                    }
                    return;
                }
                catch(e){
           
                }
            }
        },
        watch: {
            $route(to, from) {
                this.current_route = to;

                // window.scrollTo(0,0);
                let pages = ['Product', 'Products'];
                if(!pages.includes(to.name)) {
                    setMetaTags('Majestic Wine subscriptions, Subscriptions, Monthly wine subscriptions, Best wine subscriptions, Wine tasting.', 'Our subscriptions can take you on a journey to show what loving wine can do for you. Join Majestic and begin your wine adventure.', '');
                }
                
                this.show_header = true;
                let hide_header = ['AdminControlPanel'];
                let hide_top_banner = ['AdminControlPanel'];
  
                if (hide_header.includes(to.name)) {
                    this.show_top_navigation = false;
                    this.show_footer = false;
                }

                if (hide_top_banner.includes(to.name)) {
                    this.show_top_navigation = false;
                    this.show_footer = false;
                }

                this.wineclub = false;

                this.handleSubscriptionHeaders(to);

                if(to.path.includes('/admin/')) {
                    this.page_name = to.name;

                    if(to.name == 'Page Builder'){ //On page builder auto shrink sidebar
                        this.admin_side_menu_expanded = false;
                        this.show_admin_top_bar = false;
                        this.show_admin_side_bar = false;
                    }
                    else{
                         this.admin_side_menu_expanded = true;
                        this.show_admin_top_bar = true;
                        this.show_admin_side_bar = true;
                    }

                }

                if(!to.path.includes('/admin/')) {
                    this.trackOtherPages(to);
                }
            }
        },
        beforeMount() {
            window.onpopstate = (event) =>{ //Loading page from a back button event
                this.popstate_event = event;
                if(event){
                    return;
                }
            }

            if(window.location.pathname.includes("/admin/")){
                this.setTheme('admin');
                this.route = 'admin_control_panel';
                this.checkAdminAccessTemp();
            } 
            else{
                this.setTheme('itim_shop');
            }
        },
        mounted() {
            this.CheckMobileMode();
            this.getUserInfo();
            this.checkAdminAccess();
        },
    }
</script>

<style lang="scss">
.itim-shop-container{
    display: flex;
    flex-direction: column;
}

.main-body {
	min-height: calc(100vh - var(--top-nav-bar-height) - var(--footer-height)); //push footer down to bottom of page
    margin-top: calc(var(--top-nav-bar-height)); //Offset body to take into account header
    overflow-x: clip; //Hide scroll bar x without adding an extra y scrollbar
    @media (max-width: 768px) {
        margin-top: calc(var(--top-nav-bar-height));
    }
}

.main-body.remove-margin{
    margin-top: 0;
}

.admin-control-panel-container{
    display: flex;
    background-color: var(--background-colour);
    overflow-x: clip;
    font-family: var(--cms-font-family);
}

.admin-control-panel-body{
    padding: 0px 30px;
    flex-grow: 1;
}

.admin-control-panel-body.body-no-padding{
    padding: 0px !important;
}

.admin-control-inner-wrapper{
    flex-grow: 1;
    display: flex;
    flex-direction: column;
}
</style>